var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"text-left px-8 md:px-10 pb-4 md:pb-6"},[_vm._t("default"),_c('h3',{staticClass:"text-2xl font-semibold font-heading"},[_vm._v(_vm._s(_vm.props.heading))]),_c('p',{staticClass:"font-main w-48"},[_vm._v(_vm._s(_vm.props.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }